import React from 'react'
import { Link } from 'react-router-dom'
import enabledHorizontalTicketIcon from '../images/enabledHorizontalTicketIcon.svg'
import EnabledHorizontalMenuIcon from './EnabledHorizontalMenuIcon'
import EnabledCheckHorizontalMenuIcon from './EnabledCheckHorizontalMenuIcon'
import DisabledHorizontalMenuIcon from './DisabledHorizontalMenuIcon'
import disabledHorizontalTicketIcon from '../images/disabledHorizontalTicketIcon.svg'
import enabledCheckTicketIcon from '../images/enabledCheckTicketIcon.svg'
import disabledCheckTicketIcon from '../images/disabledCheckTicketIcon.svg'
import enabledCheckedTicketIcon from '../images/enabledCheckedTicketIcon.svg'
import disabledCheckedTicketIcon from '../images/disabledCheckedTicketIcon.svg'
import enabledInProgressIcon from '../images/enabledInProgressIcon.svg'
import disabledInProgressIcon from '../images/disabledInProgressIcon.svg'

class HorizontalTicketMenuComponent extends React.Component {
  checkAllTab () {
    if (this.props.enabled === 'all') {
      return (
        <EnabledHorizontalMenuIcon
          img={enabledHorizontalTicketIcon}
          label='Tout'
        />
      )
    }
    return (
      <DisabledHorizontalMenuIcon
        img={disabledHorizontalTicketIcon}
        label='Tout'
      />
    )
  }

  checkInProgressTab () {
    if (this.props.enabled === 'inProgress') {
      return (
        <EnabledHorizontalMenuIcon
          img={enabledInProgressIcon}
          label='En cours'
        />
      )
    }
    return (
      <DisabledHorizontalMenuIcon
        img={disabledInProgressIcon}
        label='En cours'
      />
    )
  }

  checkCheckTab () {
    if (this.props.enabled === 'check') {
      return (
        <EnabledCheckHorizontalMenuIcon
          img={enabledCheckTicketIcon}
          label='A vérifier'
        />
      )
    }
    return (
      <DisabledHorizontalMenuIcon
        img={disabledCheckTicketIcon}
        label='A vérifier'
      />
    )
  }

  checkCheckedTab () {
    if (this.props.enabled === 'checked') {
      return (
        <EnabledHorizontalMenuIcon
          img={enabledCheckedTicketIcon}
          label='Vérifié'
        />
      )
    }
    return (
      <DisabledHorizontalMenuIcon
        img={disabledCheckedTicketIcon}
        label='Vérifié'
      />
    )
  }

  render () {
    return (
      <div style={styles.container}>
        <div style={styles.content}>
          <Link style={styles.link} to='tickets'>
            {this.checkAllTab()}
          </Link>
          <Link style={styles.link} to='in-progress-tickets'>
            {this.checkInProgressTab()}
          </Link>
          <Link style={styles.link} to='tickets-to-ckeck'>
            {this.checkCheckTab()}
          </Link>
          <Link style={styles.link} to='checked-tickets'>
            {this.checkCheckedTab()}
          </Link>
        </div>
      </div>
    )
  }
}

const styles = {
  container: {
    width: '100%'
  },
  content: {
    top: '0px',
    margin: '0px',
    padding: '0px 2px 2px 3px',
    borderWidth: '2px',
    borderBottom: '2px white solid',
    marginLeft: '14px',
    paddingRight: '14px',
    height: '69px',
    borderColor: '#272C30'
  },
  icon: {
    marginTop: '1px',
    width: '38px',
    height: '40px'
  },
  enabledSection: {
    top: '0px',
    margin: '0px 0px 0px -3px',
    padding: '0px 2px 2px 3px',
    borderWidth: '2px',
    borderBottom: '2px white solid',
    width: '74px',
    height: '68px',
    float: 'left',
    borderColor: '#4880FF'
  },
  disabledSection: {
    width: '84px',
    height: '68px',
    float: 'left'
  },
  enabledLabel: {
    fontSize: '10px',
    fontWeight: 'bold',
    color: '#4880FF'
  },
  disabledLabel: {
    fontSize: '10px',
    fontWeight: 'bold',
    color: '#A6B9C8'
  },
  link: {
    textDecoration: 'none'
  }

}

export default HorizontalTicketMenuComponent
